import {
  Component, ChangeDetectionStrategy, Input,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  PlainLink, RouterOrExternalLinkDirective,
} from '@knorr-bremse-portals/ngx-components'
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon'
import {
  HeadingLevel, VariableHeadingComponent,
} from '@knorr-bremse-portals/ngx-components/components/variable-heading'
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp'
import {
  Icon, iconArrowsRight, iconInfo, iconClose,
} from '@knorr-bremse-portals/icons'

export type AbstractMode = 'visible' | 'button'

@Component({
  selector: 'figure[kb-overlay-figure]',
  templateUrl: './overlay-figure.component.html',
  styleUrls: ['./overlay-figure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOrExternalLinkDirective, IconComponent, VariableHeadingComponent, LineClampComponent],
})
export class OverlayFigureComponent {
  @Input() public heading?: string
  @Input() public headingLevel?: HeadingLevel
  @Input() public abstract?: string
  @Input() public link?: PlainLink
  @Input() public linkIcon: Icon | null = iconArrowsRight
  @Input() public headingLines = 2
  @Input() public abstractLines = 2
  @Input() public abstractMode: AbstractMode = 'visible'

  protected iconOpenCaption = iconInfo
  protected iconCloseCaption = iconClose
  protected captionOpen = false

  protected openCaption(event: MouseEvent): void {
    event.preventDefault()
    event.stopPropagation()

    this.captionOpen = true
  }

  protected closeCaption(event: MouseEvent): void {
    event.preventDefault()
    event.stopPropagation()

    this.captionOpen = false
  }
}
